import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-lab",
  "use": "icon-lab-usage",
  "viewBox": "0 0 16.94 16.93",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.94 16.93\" id=\"icon-lab\">\n  <path id=\"icon-lab_标签\" class=\"cls-1\" d=\"M1918.24,1221.56a0.8,0.8,0,0,1-.57-0.24l-9.66-9.65a0.842,0.842,0,0,1-.23-0.66l0.57-5.11a0.808,0.808,0,0,1,.71-0.71l5.11-.57a0.808,0.808,0,0,1,.66.23l9.65,9.66a0.785,0.785,0,0,1,0,1.13l-5.68,5.68A0.773,0.773,0,0,1,1918.24,1221.56Zm-8.82-10.75,8.82,8.81,4.54-4.54-8.81-8.82-4.09.46Zm4.27-1.98a1.2,1.2,0,1,1-1.7,0A1.2,1.2,0,0,1,1913.69,1208.83Z\" transform=\"translate(-1907.78 -1204.63)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/svg/lab.svg
// module id = qgwk
// module chunks = 41